import type { Fn } from '@damilaredev/utils'
import type { ComponentInternalInstance, Ref } from 'vue'
import { onActivated, onDeactivated, ref } from 'vue'

export const isHydrated = ref(false)

export const onHydrated = (cb: () => unknown) => {
  watchOnce(isHydrated, () => cb(), { immediate: isHydrated.value })
}

export function useDeactivated(): Ref<boolean> {
  const deactivated = ref(false)
  onActivated(() => (deactivated.value = false))
  onDeactivated(() => (deactivated.value = true))

  return deactivated
}

export function onReactivated(
  hook: Fn,
  target?: ComponentInternalInstance | null,
): void {
  const initial = ref(true)
  onActivated(() => {
    if (initial.value) {
      return
    }
    hook()
  }, target)

  onDeactivated(() => (initial.value = false))
}
